<template>
  <div v-if="show" class="sh-block-menu" v-click-outside="close">
    <i class="fal fa-ellipsis-h sh-block-menu-btn" aria-label="More options" @click.stop="open = !open"></i>
    <ul v-if="open" class="sh-block-menu-dropdown">
      <li class="sh-block-menu-item" @click="request('unblock')">Unblock user</li>
    </ul>
    <BlockUserConfirm :visible="confirmOpen" :mode="mode" @confirm="confirm" @cancel="confirmOpen = false" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { userInfo } from "../common/user-info";
import BlockUserConfirm from "./BlockUserConfirm.vue";
import clickOutside from "../directives/v-click-outside.js";

// Minimal ellipsis menu for content that has no menu of its own — comments,
// replies, activity feed. Blocking is only offered from private/group
// messaging, so this menu only appears once the author is already blocked
// and offers Unblock. Hidden on the viewer's own content.
export default {
  name: "BlockUserMenu",
  components: { BlockUserConfirm },
  directives: { "click-outside": clickOutside },
  props: {
    userId: { type: [Number, String], required: true },
    // Content the block was made from, for the Slack alert's context.
    contentUid: { type: [Number, String], default: null }
  },
  data() {
    return { open: false, confirmOpen: false, mode: "block" };
  },
  computed: {
    ...mapGetters("blockedUsers", ["isUserBlocked"]),
    mine() {
      return parseInt(this.userId) === parseInt(userInfo()?.user_id);
    },
    show() {
      return this.userId != null && !this.mine && this.blocked;
    },
    blocked() {
      return this.isUserBlocked(this.userId);
    }
  },
  methods: {
    ...mapActions("blockedUsers", ["blockUser", "unblockUser"]),
    close() {
      this.open = false;
    },
    request(mode) {
      this.open = false;
      this.mode = mode;
      this.confirmOpen = true;
    },
    confirm() {
      this.confirmOpen = false;
      if (this.mode === "unblock") {
        this.unblockUser({ userId: this.userId });
      } else {
        this.blockUser({ userId: this.userId, contentUid: this.contentUid });
      }
    }
  }
};
</script>

<style scoped>
.sh-block-menu {
  position: relative;
  display: inline-block;
  margin-left: auto;
}

.sh-block-menu-btn {
  padding: 4px 6px;
  color: #525151;
  font-size: 16px;
  cursor: pointer;
}

.sh-block-menu-btn:hover {
  color: #1a1a1a;
}

.sh-block-menu-dropdown {
  position: absolute;
  top: 24px;
  right: 0;
  z-index: 5;
  min-width: 160px;
  margin: 0;
  padding: 4px 0;
  list-style: none;
  background-color: #fff;
  border: 1px solid #e6e8eb;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  text-align: left;
}

.sh-block-menu-item {
  padding: 8px 14px;
  font-size: 14px;
  color: #1a1a1a;
  white-space: nowrap;
  cursor: pointer;
}

.sh-block-menu-item:hover {
  background-color: #f4f6f8;
}
</style>
